<template>
	<v-container>
		<form class="filterContainer">
			<!-- Mandator -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-model="formState.selectedMandators"
						:items="formItems.mandator"
						hide-selected
						label="Mandator"
						persistent-hint
						chips
						return-object
						v-show="mandatorVisible"
					></v-autocomplete>
				</v-col>
			</v-row>
			<!-- Date -->
			<v-row >
			<v-col cols="12" md="12">
					<v-menu
						ref="menuFrom"
						v-model="menuFrom"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateTemp"
								label="Event Date"
								v-bind="attrs"
								v-on="on"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateFinal"
							no-title
							@input="menuFrom = false"
							:first-day-of-week="1"
						></v-date-picker>
					</v-menu>
			</v-col>
			</v-row>

			<!-- Sales Channel -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-model="formState.selectedSalesChannels"
						:items="formItems.salesChannels"
						hide-selected
						label="Sales Channel"
						multiple
						persistent-hint
						chips
						return-object
					>
					</v-autocomplete>
				</v-col>
			</v-row>

		<!-- Service Provider -->
		<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-model="formState.selectedServiceproviders"
						:items="formItems.serviceproviders"
						hide-selected
						label="Serviceprovider *"
						persistent-hint
						chips
						return-object
						:rules="[v => (v && v.length === 1) || 'Serviceprovider is required. Single selection only.']"
						:error="!formState.selectedServiceproviders || formState.selectedServiceproviders.length !== 1"
						:error-messages="!formState.selectedServiceproviders || formState.selectedServiceproviders.length !== 1 ? 'Serviceprovider is required. Single selection only.' : ''"
						multiple
						:multiple-max="1"
					></v-autocomplete>
				</v-col>
		</v-row>
			<!-- Product group-->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedProducts"
						:items="formItems.products"
						hide-selected
						label="Product Name (SKU)"
						multiple
						persistent-hint
						chips
						return-object
					>
					</v-autocomplete>
				</v-col>
				<!-- Product SKU -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedSkuGroups"
						:items="formItems.skuGroups"
						hide-selected
						label="Product group"
						multiple
						persistent-hint
						chips
						return-object
					>
					</v-autocomplete>
				</v-col>
			</v-row>

			<!-- Booking / Refund -->
			<v-row>
				<v-col cols="12" md="6">
					<v-combobox
						v-model="formState.selectedBookings"
						:items="formItems.booking"
						label="Booking / refund"
						multiple
						chips
					></v-combobox>
				</v-col>
				<!-- Reseller -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedResellers"
						:items="formItems.resellers"
						hide-selected
						label="Reseller"
						multiple
						persistent-hint
						chips
						return-object
					>
					</v-autocomplete>
				</v-col>
			</v-row>

			<v-btn
				:disabled="loading || !isFormValid"
				color="primary"
				class="searchButton"
				@click="submit"
				>{{ txt.button.showData }}
			</v-btn>

			<v-layout align-center justify-center class="dataLoading">
				<v-progress-circular
					indeterminate
					color="primary"
					v-show="loading"
				></v-progress-circular>
			</v-layout>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'

export default {
	name: 'ParticipantReportFilter',
	props: ['loading'],
	data() {
		return {
			formState: {
				selectedMandators: [],
				selectedSalesChannels: [],
				selectedServiceproviders: [],
				selectedProducts: [],
				selectedSkuGroups: [],
				dateFinal: new Date().toISOString().substr(0, 10),
				dateTemp: new Date().toISOString().substr(0, 10),
				selectedBookings: [{ text: 'Bookings', value: 0 }],
				selectedResellers: [],
			},
			formItems: {
				mandator: ['Mandators could not be loaded'],
				salesChannels: ['Sales channels could not be loaded'],
				serviceproviders: ['Service providers could not be loaded'],
				products: ['Products could not be loaded'],
				skuGroups: ['Product groups could not be loaded'],
				booking: [
					{ text: 'Bookings', value: 0 },
					{ text: 'Refunds', value: 1 },
				],
				resellers: ['Resellers could not be loaded'],
			},
			txt: {
				button: {
					showData: 'Show Data',
				},
				mandatorAlert: 'Please select at least one mandator.',
				dateAlert: 'Incorrect date. The correct format is YYYY-MM-DD',
			},
			loadingData: false,
			menuFrom: false,
			mandatorVisible: true,
			appName: 'pt',
		}
	},
	computed: {
		isFormValid() {
			return this.formState.selectedServiceproviders && 
				this.formState.selectedServiceproviders.length === 1
		},
	},
	methods: {
		async getMandators() {
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.get(`${config.baseAPIurl}/participant-report/mandators`)
				this.formItems.mandator = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getServiceProviders(installationId) {
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/participant-report/service-providers?installationid=${installationId}`)
				this.formItems.serviceproviders = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getSalesChannels(installationId) {
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/participant-report/sales-channel?installationid=${installationId}`)
				this.formItems.salesChannels = res.data
			} catch (err) {
				console.log(err)
			}
		},
		async getProducts(installationId) {
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/participant-report/products?installationid=${installationId}`)
				this.formItems.products = res.data
				// eslint-disable-next-line max-len
				this.formItems.skuGroups = Array.from(new Set(this.formItems.products.map((el) => el.value.split('.')[0]).sort()))
			} catch (err) {
				console.log(err)
			}
		},
		async getResellers(installationId) {
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/participant-report/reseller?installationid=${installationId}`)
				this.formItems.resellers = res.data
			} catch (err) {
				console.log(err)
			}
		},
		mandatorAutofill() {
			if (this.formItems.mandator.length === 1) {
				this.formState.selectedMandators = this.formItems.mandator[0]
				this.mandatorVisible = false
			}
		},
		notEmptyMandator() {
			if (this.formState.selectedMandators.length === 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Required field'
			} else {
				this.mandatorErrorCount = 0
				this.mandatorErrorMessage = ''
			}
		},
		submit() {
			this.$emit('submit', this.formState)
		},
		enforceServiceProviderLimit() {
			if (this.formState.selectedServiceproviders.length > 1) {
				this.formState.selectedServiceproviders = [
					this.formState.selectedServiceproviders[this.formState.selectedServiceproviders.length - 1]
				]
			}
		}
	},

	watch: {
		'formState.dateFinal': {
			handler() {
				this.formState.dateTemp = this.formState.dateFinal
			},
		},
		'formItems.mandator': {
			handler() {
				this.mandatorAutofill()
				this.notEmptyMandator()
			},
		},
		'formState.selectedMandators': {
			handler() {
				this.getServiceProviders(this.formState.selectedMandators.value)
				this.getSalesChannels(this.formState.selectedMandators.value)
				this.getProducts(this.formState.selectedMandators.value)
				this.getResellers(this.formState.selectedMandators.value)
			},
		},
		'formState.selectedServiceproviders': {
			handler() {
				this.enforceServiceProviderLimit()
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators()
		})
	},

}
</script>

<style scoped>
form {
	padding: 60px 60px 0px 30px;
}
.searchButton {
	color: #00a0e3;
}
.filterContainer {
	padding: 0px !important;
}
.dataLoading {
	padding-top: 11px;
}

</style>
